// React
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

// Grommet
import { ResponsiveContext } from 'grommet'

import { useParams } from 'react-router-dom'

// Appt
import Box from '../../components/simple/box/Box'
import Text from '../../components/simple/text/Text'
import LocalStorageService from '../../services/LocalStorageService'
import UserService from '../../services/UserService'
import Select from '../../components/simple/input/Select'
import H2 from '../../components/simple/heading/H2'
import ConnectionCheck from '../../components/compound/connectionCheck/ConnectionCheck'

import { SHOW_UAT_BANNER, CURRENT_VERSION, SERVER_LABEL } from "../../env";

/**
 * `BreadcrumbBar` renders a box with 'quick Actions' and action buttons
 */
function BreadcrumbBar (props) {

  const [studentValues, setStudentValues] = useState([]);
  const [allStudentValues, setAllStudentValues] = useState([]);
  const [activeStudent, setActiveStudent] = useState(null);

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const activeUser = LocalStorageService.get('userDetails')
  const terms = LocalStorageService.get('terms');

  const params = useParams()
  const id = params.id

  const navigate = useNavigate()

    const getUsers = async (type = 'user') => {
          const params = {
              fields: 'id,firstName,lastName,reference,type',
              limit: 2000,
              orgId: activeOrg.id,
              showFormerStudents: 'false',
              type,
          };

          //   setLoading(true);
          const users = await UserService.getUsers(apiToken, params);
          if (!users || users?.error) {
              // NotificationService.error(users.error)
          } else {
              // if (!unmounted) {
              if (users?.error) {
                  setStudentValues(null);
                  setAllStudentValues(null)
              } else if (users?.data) {
                  var studentUsers = [];
                  for (const thisUser of users.data) {
                  if (thisUser.firstName && thisUser.lastName) {
                      studentUsers.push({
                      id: thisUser.id,
                      learnerNumber: thisUser.reference,
                      name: thisUser.firstName + ' ' + thisUser.lastName,
                      });
                  }
                  }
                  studentUsers = studentUsers.sort((a, b) => a.name.localeCompare(b.name));
                  setStudentValues(studentUsers);
                  setAllStudentValues(studentUsers);
              }
              // }
          }

      }

      useEffect(() => {
        getUsers('student');
      }, []);


      useEffect(() => {
          if (id && studentValues.length > 0) {
              const selectedStudent = studentValues.find((student) => parseInt(student.id) === parseInt(id));
              setActiveStudent(selectedStudent);
          }
        }, [studentValues, id]);



  return (<>

    <ConnectionCheck />


    {SHOW_UAT_BANNER === "true" && <Box background='besmartOrange' height="xxsmall" direction='row' gap='small' margin={{ bottom: 'medium' }} round='small' justify='between' align='center'>
      <Box direction='column' pad={{ horizontal: 'medium', vertical: 'small' }}>
        <Text color='besmartBlue' weight='bold'>WARNING - This is a demo site - data will be reset regularly. ({SERVER_LABEL || 'dev'} - v{CURRENT_VERSION || '0.0.0'})</Text>
      </Box>
    </Box>}




    <ResponsiveContext.Consumer>
      {responsive => (
        <Box background='white' direction='row' height="xsmall" gap='small' margin={{ bottom: 'medium' }} round='small' justify='between' align='center'>
          <Box direction='column' pad={{ horizontal: 'medium' }}>
            {props.title && <H2 color='besmartBlue' margin={{ top: 'small', bottom: 'small' }} truncate>{props.title}</H2>}
          </Box>

          <Box direction='row' pad={{ horizontal: 'medium' }}>
              {props.children}

              <Box
                justify="between"
                margin={{ horizontal: 'medium', vertical: 'small' }}
                border={{ side: 'all', color: 'brand', size: 'medium' }}
                round="small"

              >
                  <Select

                      onChange={({ option }) => navigate('/serviceuser/' + option.id + '/profile')}
                      labelKey="name"
                      onKeyDown={event => {
                        // alert(event.key);

                          // set the first student as active student if enter is pressed
                          if (event.key === 'Enter' && !activeStudent && studentValues && studentValues.length > 0) {
                              setActiveStudent(studentValues[0]);
                              // navigate('/record/' + studentValues[0].id);
                              navigate('/serviceuser/' + studentValues[0].id + '/profile');
                          }
                      }}
                      value={activeStudent ? [activeStudent] : []}
                      placeholder={(terms?.serviceUser || 'service user') + ' Profile'}
                      options={studentValues}
                      onSearch={text => {

                          // The line below escapes regular expression special characters:
                          // [ \ ^ $ . | ? * + ( )
                          const escapedText = text.replace(
                          /[-\\^$*+?.()|[\]{}]/g,
                          '\\$&',
                          );
                          // Create the regular expression with modified value which
                          // handles escaping special characters. Without escaping special
                          // characters, errors will appear in the console
                          const exp = new RegExp(escapedText, 'i');

                          setStudentValues(
                            allStudentValues.filter(o => exp.test(o.name)),
                          );
                      }}
                      valueKey={{ key: 'id', reduce: false }}
                      border={false}
                      round="small"
                      focusIndicator={false}
                      plain
                      margin={{ left: 'small', right: 'small' }}
                  />
              </Box>



          </Box>


        </Box>)}
    </ResponsiveContext.Consumer>
    </>)
}

// BreadcrumbBar.defaultProps = {
//   label: 'Quick Actions'
// }

BreadcrumbBar.propTypes = {
  /**
   * Note that the title is passed as a child of the BreadcrumbBar
   *
   */
  /**
   * The route location
   */
  path: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ])
}

export default BreadcrumbBar
